import { render } from "./RegisterPage.vue?vue&type=template&id=460fc62a&scoped=true&ts=true"
import script from "./RegisterPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&lang=ts"

import "./RegisterPage.vue?vue&type=style&index=0&id=460fc62a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460fc62a"]])

export default __exports__